import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import Home from "./elements/Home";
import Signup from "./elements/Signup";
import Login from "./elements/Login";
import Pricing from "./elements/Pricing";
import Activate from "./elements/Activate";
import Dashboard from "./elements/Dashboard";
import Payment from "./elements/Payment";
import PaymentSuccess from "./elements/PaymentSuccess";
import PaymentFail from "./elements/PaymentFail";
import Contact_Us from "./elements/Contact_Us";
import Contact from "./elements/Contact";
import Forgot_Password from "./elements/Forgot_Password";
import Login_Redirect_Handler from "./elements/Login_Redirect_Handler";
import Profile from "./elements/Profile";
import Payment_History from "./elements/Payment_History";
import Cancel from "./elements/Cancel";
import Terms from "./elements/Terms";
import Privacy from "./elements/Privacy";
import FAQ from "./elements/FAQ";
import Change_Plan from "./elements/Change_Plan";
import Referral from "./elements/Referral";
import Referral_Dashboard from "./elements/Referral_Dashboard";
import ResetPassword from "./elements/ResetPassword";
import Admin_Login from './elements/Admin_Login';
import Admin_Dashboard from './elements/Admin_Dashboard';
import News_Management from './elements/News_Management';
import { useAuth } from "./AuthContext";
import ProtectedRoute from './ProtectedRoute';
import Support_Request from "./elements/Support_Request";


function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/signup" element={<Signup />} />
        <Route path="/Login" element={<Login />} />
        <Route path="/signup_activate" element={<Login_Redirect_Handler />} />
        <Route path="/activate" element={<Activate />} />
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/change_plan" element={<Change_Plan />} />
        <Route path="/payment" element={<Payment />} />
        <Route path="/pricing" element={<Pricing />} />
        <Route path="/contact_us" element={<Contact_Us />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/forgot_password" element={<Forgot_Password />} />
        <Route path="/profile" element={<Profile />} />
        <Route path="/payment_history" element={<Payment_History />} />
        <Route path="/cancel" element={<Cancel />} />
        <Route path="/faq" element={<FAQ />} />
        <Route path="/terms" element={<Terms />} />
        <Route path="/privacy" element={<Privacy />} />
        <Route path="/paymentsuccess" element={<PaymentSuccess />} />
        <Route path="/paymentfail" element={<PaymentFail />} />
        <Route path="/referral" element={<Referral />} />
        <Route path="/referral_dashboard" element={<Referral_Dashboard />} />
        <Route path="/reset-password/:token" element={<ResetPassword />} />
        
        <Route path="/admin_login" element={<Admin_Login />} />
        <Route path="/admin_dashboard" element={<ProtectedRoute><Admin_Dashboard /></ProtectedRoute>} />
        <Route path="/news_management" element={<ProtectedRoute><News_Management /></ProtectedRoute>} />
        <Route path="/support_request" element={<ProtectedRoute><Support_Request /></ProtectedRoute>} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;